import { NgModule } from '@angular/core';
import { ProvisionRequestsStoreService } from './provision-requests-store.service';

@NgModule({
  imports: [],
  providers: [ProvisionRequestsStoreService],
  exports: [],
})
export class ProvisionRequestsStoreModule {}
